__turbopack_context__.v({
  "aboutContainer": "about-module__EDPR9a__aboutContainer",
  "aboutContent": "about-module__EDPR9a__aboutContent",
  "bioCard": "about-module__EDPR9a__bioCard",
  "bioContent": "about-module__EDPR9a__bioContent",
  "bioIcon": "about-module__EDPR9a__bioIcon",
  "cvButton": "about-module__EDPR9a__cvButton",
  "educationCard": "about-module__EDPR9a__educationCard",
  "educationSection": "about-module__EDPR9a__educationSection",
  "profileActions": "about-module__EDPR9a__profileActions",
  "profileBadge": "about-module__EDPR9a__profileBadge",
  "profileButton": "about-module__EDPR9a__profileButton",
  "profileImage": "about-module__EDPR9a__profileImage",
  "profileLocation": "about-module__EDPR9a__profileLocation",
  "profilePhoto": "about-module__EDPR9a__profilePhoto",
  "profileSection": "about-module__EDPR9a__profileSection",
  "profileText": "about-module__EDPR9a__profileText",
  "profileTitle": "about-module__EDPR9a__profileTitle",
  "valuesCard": "about-module__EDPR9a__valuesCard",
});
